"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.add = void 0;
const common_1 = require("@finley-technologies/common");
const add = ({ leftValue, rightValue, }) => {
    // Handle left hand side input with full date string
    if (typeof leftValue === 'string' && typeof rightValue === 'number') {
        // Validate full date string format
        if (common_1.typeguards.isFullDateStr(leftValue)) {
            const result = common_1.date.addDays(leftValue, rightValue);
            return { error: null, result };
        }
        return {
            error: `Addition error: left hand value provided was a string, but did not conform to the expected date format of yyyy-mm-dd | Inputs: [${leftValue}, ${rightValue}]`,
        };
    }
    // Handle right hand side input with full date string
    if (typeof leftValue === 'number' && typeof rightValue === 'string') {
        // Validate full date string format
        if (common_1.typeguards.isFullDateStr(rightValue)) {
            const result = common_1.date.addDays(rightValue, leftValue);
            return { error: null, result };
        }
        return {
            error: `Addition error: right hand value provided was a string, but did not conform to the expected date format of yyyy-mm-dd | Inputs: [${leftValue}, ${rightValue}]`,
        };
    }
    if (typeof leftValue !== 'number' || typeof rightValue !== 'number') {
        return {
            error: `Addition error: inputs must be numbers, received: [${leftValue}, ${rightValue}]`,
        };
    }
    const result = leftValue + rightValue;
    return { error: null, result };
};
exports.add = add;
//# sourceMappingURL=add.js.map